import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class AmountsAgenciesAdd extends Component{
	render(){
		const {amounts_agencies} =this.props;
		let ac = _.find(amounts_agencies.permissions, (o) => {return o==='Create'});
		return (
		ac ? <p>
				<NavLink to={`/instancias/montos/crear`} className="button is-small is-inm-purple">{'Agregar Monto de Instancia'}</NavLink>
			</p>:''
		)
	}
}

export default SecureLayout(AmountsAgenciesAdd);


// WEBPACK FOOTER //
// ./src/elements/agencies/widget/amounts_add.jsx